import { onMounted, onUnmounted, ref } from "vue";

// How much of the bottom of the screen the on-screen keyboard covers, so things pinned
// to the bottom can sit just above it instead of behind it. Small changes (the browser's
// own toolbars sliding about) don't count.
export function useKeyboardInset() {
  const inset = ref(0);
  const update = () => {
    const viewport = window.visualViewport;
    if (!viewport) return;
    const covered = window.innerHeight - viewport.height - viewport.offsetTop;
    inset.value = covered > 80 ? Math.round(covered) : 0;
  };
  onMounted(() => {
    window.visualViewport?.addEventListener("resize", update);
    window.visualViewport?.addEventListener("scroll", update);
    update();
  });
  onUnmounted(() => {
    window.visualViewport?.removeEventListener("resize", update);
    window.visualViewport?.removeEventListener("scroll", update);
  });
  return inset;
}
